const constant = {
    SOMETHING_WENT_WRONG : 'Something went wrong!!!',
    DELETE_REIMBURSEMENT_POPUP_MESSAGE: 'Deleting this Reimbursement will erase all data inside this record. Are you sure you want to delete this Reimbursement?'
}
module.exports = constant;